import { useState } from "react";
import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";

export function LabSampleViewModel(logout, addSnackbar, id = null) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [labSample, setLabSample] = useState(null);
  const [labs, setLabs] = useState([
    { value: -1, label: "Select Laboratories" },
  ]);
  const [loading, setLoading] = useState(!!id);
  const [inProgress, setInProgress] = useState(false);

  const isEdit = !!id;

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  const getLabSampleDetails = async function () {
    if (!id) return;

    let callResult = await makeGetApiCall(`labSamples/${id}`);

    if (callResult.success) {
      setLabSample(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  const getLabsForDropdown = async function () {
    let callResult = await makePostApiCall(`laboratoriesForDropdown`);

    if (callResult.success) {
      setLabs([
        { value: -1, label: "Select Laboratories" },
        ...callResult.data,
      ]);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        const message = "Could not load laboratories";
        showErrorModal(message);
      }
    }
  };

  const createLabSample = async function (values, files) {
    setInProgress(true);
    const jsonPayload = { ...values };
    let callResult = await makePostApiCall("labSamples/create", jsonPayload);
    setInProgress(false);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Lab sample created successfully",
          SnackbarType.Success
        )
      );
      return { success: true, data: callResult.data };
    }

    if (callResult.errorStatus === 401) {
      logout();
      return { success: false };
    }
    const message = "Unable to create lab sample";
    showErrorModal(message);

    return { success: false, message };
  };

  const updateLabSample = async function (payload) {
    setInProgress(true);

    const statusValue = payload.status.value;
    const labIdValue = payload.lab_id;

    let callResult = await makePostApiCall(
      `labSamples/${id}/update`,
      {
        ...payload,
        status: statusValue,
        lab_id: labIdValue,
        laboratory: null,
      },
      "multipart/form-data"
    );

    setInProgress(false);

    if (callResult.success) {
      let message = "Lab sample updated successfully";
      addSnackbar(
        new SnackbarData(generateUniqueNumber(), message, SnackbarType.Success)
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    loading,
    labSample,
    labs,
    inProgress,
    isEdit,
    getLabSampleDetails,
    getLabsForDropdown,
    createLabSample,
    updateLabSample,
  };
}

export default LabSampleViewModel;
